import type { Pagination } from 'models';
import { generateQueryKey } from 'query';
import type { CommunitiesListFilter, CommunitiesUsersListFilter, CommunityScope } from '../types';
import type { NodeCommunitiesQueryFilter } from './useGetNodeCommunities';

type CommunitiesParams = {
  filter?: CommunitiesListFilter;
  pagination?: Partial<Pagination>;
};

type CommunitiesUsersParams = {
  filter?: Partial<CommunitiesUsersListFilter>;
  pagination?: Partial<Pagination>;
};

type NodeCommunitiesParams = {
  filter?: NodeCommunitiesQueryFilter;
  pagination?: Partial<Pagination>;
};

export const getCommunityDataObjectQueryKey = ({ id }: { id?: string }) =>
  generateQueryKey(['data-object', ...getCommunityQueryKey({ id })]);

export const getCommunityQueryKey = ({ id, invitationToken }: { id?: string; invitationToken?: string }) =>
  generateQueryKey([
    'communities',
    {
      id,
      invitationToken: invitationToken ?? null,
    },
  ]);

export const getCommunityPublicQueryKey = ({ id }: { id?: string }) =>
  generateQueryKey(['communities', 'public', { id }]);

// TODO: create query key as const - 82948
export const getCommunityUsersKey = ({ filter = {}, pagination = {} }: CommunitiesUsersParams) =>
  generateQueryKey(['communities', 'users', { filter, pagination }]);

export const getCommunityUsersInfiniteQueryKey = ({ filter = {}, pagination = {} }: CommunitiesUsersParams) =>
  generateQueryKey([...getCommunityUsersKey({ filter, pagination }), 'infinite']);

export const getCommunityNotificationsKey = ({ id }: { id: string }) =>
  generateQueryKey([...getCommunityQueryKey({ id }), 'notifications']);

export const getCommunityMembersKey = ({ communityId, pageSize }: { communityId?: string; pageSize?: number }) =>
  generateQueryKey(['communities', 'members', { communityId, pageSize }]);

export const getCommunitiesInfiniteQueryKey = ({ filter = {}, pagination = {} }: CommunitiesParams) =>
  generateQueryKey(['communities', 'list', 'infinite', { filter, pagination }]);

export const getCommunitiesQueryKey = (params: {
  featured?: boolean;
  organizationId?: string;
  pagination?: Pagination;
  scope?: CommunityScope;
  search?: string;
}) => generateQueryKey(['communities', 'list', params]);

export const getInvitationTokenQueryKey = (params: { communityId: string }) =>
  generateQueryKey(['communities', 'invitation-token', params]);

export const getNodeCommunitiesListQueryKey = ({ filter, pagination }: NodeCommunitiesParams) =>
  generateQueryKey(['communities', 'node', { filter, pagination }]);
